import { initAll } from 'govuk-frontend/dist/govuk/govuk-frontend.min';
import HMRCFrontend from './all';

initAll();
HMRCFrontend.initAll();
